import { render, staticRenderFns } from "./ShipmentScanner.vue?vue&type=template&id=8260a374&scoped=true&"
import script from "./ShipmentScanner.vue?vue&type=script&lang=js&"
export * from "./ShipmentScanner.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentScanner.vue?vue&type=style&index=0&id=8260a374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8260a374",
  null
  
)

export default component.exports